import * as React from "react";
import { IParagraphFeaturedOffersProps } from "./ParagraphFeaturedOffersProps";
import { StyledContainer } from "./ParagraphFeaturedOffersHelpers";
import { graphql } from "gatsby";
import FeaturedOffers from "../../common/FeaturedOffers/FeaturedOffers";

const ParagraphFeaturedOffers: React.FC<IParagraphFeaturedOffersProps> = (
  props
) => {
  return (
    <StyledContainer>
      <FeaturedOffers {...props} />{" "}
    </StyledContainer>
  );
};

export const fragment = graphql`
  fragment ParagraphFeaturedOffers on paragraph__featured_offers {
    id
    parent_type
    field_subtitle
    field_promo_code
    field_title
    field_description
    field_link {
      url
      title
    }
    relationships {
      offers: field_node_offers {
        id
        title
        field_subtitle
        field_promo_code
        field_minimum_length_stay
        field_lead_days
        field_publish_start_date_time
        field_unpublish_start_date_time
        field_external_link {
          title
          uri
          url
        }
        path {
          alias
        }
        description: body {
          summary
          processed
        }
        relationships {
          field_site_list {
            machine_name
          }
          field_rate_code {
            code
          }
          field_teaser_image {
            relationships {
              field_media_image {
                publicUrl
                gatsbyImage(
                  width: 640
                  height: 480
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      }
      hotel: hotel {
        path {
          alias
        }
      }
    }
  }
`;

export default ParagraphFeaturedOffers;
